module.exports = __webpack_public_path__ + "media/images/kannada-matrimony-banner-e5de5389b692c0ad5f7c93f56b3f0594.jpg";